import { render, staticRenderFns } from "./CommentItem.vue?vue&type=template&id=0d616e95&scoped=true"
import script from "./CommentItem.vue?vue&type=script&lang=js"
export * from "./CommentItem.vue?vue&type=script&lang=js"
import style0 from "./CommentItem.vue?vue&type=style&index=0&id=0d616e95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d616e95",
  null
  
)

export default component.exports